import { defineComponent as _defineComponent } from 'vue'
import Price from 'JS/components/price/Price.vue';
import UiButton from 'JS/components/UiButton.vue';
import { CardWidgetItemData } from 'JS/dxp/types/widgets/card-widget';
import { computed } from 'vue';
import { createPromoDataAttributes } from 'JS/utilities/analytics';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardWidgetCard',
  props: {
    item: null,
    index: null,
    widgetId: null
  },
  setup(__props: any) {

const props = __props as {
	item: CardWidgetItemData,
	index: number,
	widgetId: string,
}



const gaDataAttributes = computed(() => createPromoDataAttributes({
	promoId: props.item.urlSlug.replace("https://www.farmandfleet.com", ""),
	promoName: `${props.item.heading}. ${props.item.subheading ?? ''}`.trim(),
	creativeSlot: `dxp_card_${props.index + 1}`,
	creativeName: `dxp_card`,
}));

return { __sfc: true,props, gaDataAttributes, Price, UiButton }
}

})